export default "__VITE_ASSET__66ed27ae__"